export enum Features {
  // please keep this one at all times, is used for testing
  // and should stay even if no feature toggle is used at the moment
  FEATURE_TOGGLE_TEST = 'FEATURE_TOGGLE_TEST',
  // normal Features go here:
  GRAPHQL_GDPR_SELF_ASSESSMENT = 'GRAPHQL_GDPR_SELF_ASSESSMENT',
  MUNICH_DEMO = 'MUNICH_DEMO',
  DSBOSS_SCENARIOS_TABLE_PACE = 'DSBOSS_SCENARIOS_TABLE_PACE',
  EMERGENCY_DISABLE_SERVICE = 'EMERGENCY_DISABLE_SERVICE',
  STOP_NETWORK_IMPORTS = 'STOP_NETWORK_IMPORTS',
  SERVICE_BREAK_LOCATIONS = 'SERVICE_BREAK_LOCATIONS',
  KPI_DASHBOARD_ANNOTATIONS = 'KPI_DASHBOARD_ANNOTATIONS',
  DAMAGE_REPORT_V2 = 'DAMAGE_REPORT_V2',
  AD_REMOTE_EMERGENCY_STOP = 'AD_REMOTE_EMERGENCY_STOP',
  VEHICLE_CAPACITY_CONFIG = 'VEHICLE_CAPACITY_CONFIG',
  ADMIN_PANEL_PERMISSIONS_UI = 'ADMIN_PANEL_PERMISSIONS_UI',
  BULK_EDIT_AND_DELETE_STOPS = 'BULK_EDIT_AND_DELETE_STOPS',
  CUSTOMER_SEARCH_V2 = 'CUSTOMER_SEARCH_V2',
} // DONT DELETE - template injection feature
